"use client";
import { FC, useMemo, useEffect } from "react";
import { IntegrationsData, integrationsData } from "./IntegrationsData";
import TabsContent from "./TabsContent";
import { FaPlug } from "react-icons/fa6";

interface IntegrationListProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  activeTab: string;
}

const IntegrationList: FC<IntegrationListProps> = ({
  searchTerm,
  setSearchTerm,
  activeTab,
}) => {
  const filteredIntegrations = useMemo(() => {
    let data = integrationsData;

    if (activeTab) {
      data = { [activeTab]: integrationsData[activeTab] };
    }
    if (searchTerm.trim().length) {
      const filteredData: IntegrationsData = {};
      Object.entries(integrationsData).forEach(([key, data]) => {
        const list = data.listData.filter(
          (integration) =>
            integration.title
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            integration.description
              .toLowerCase()
              .includes(searchTerm.toLowerCase()),
        );

        if (list.length) {
          filteredData[key] = {
            label: data.label,
            listData: list,
          };
        }
      });
      return filteredData;
    }
    return integrationsData;
  }, [activeTab, searchTerm]);

  return (
    <>
      <input
        type="search"
        placeholder="Search integrations globally..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="z-20 w-full rounded-lg border border-[#CECECE] px-4 py-2 text-[#202020] placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-[#ffffff1a]"
      />
      {Object.values(filteredIntegrations).every(
        ({ listData }) => !listData.length,
      ) ? (
        <div className="flex h-96 flex-col items-center justify-center space-y-4">
          <FaPlug className="h-12 w-12 text-[#202020]" />
          <div className="space-y-2 text-center">
            <p className="text-xl font-bold text-[#202020]">
              No Integrations Found
            </p>
            <p className="text-[#202020]">
              Try adjusting your search or explore other categories
            </p>
          </div>
        </div>
      ) : (
        Object.entries(filteredIntegrations).map(
          ([key, { label, listData }]) => {
            if (!listData.length) return <></>;
            return (
              <div key={key} className="mb-4 lg:mb-8">
                <TabsContent tabId={key} label={label} listData={listData} />
              </div>
            );
          },
        )
      )}
    </>
  );
};

export default IntegrationList;
